export default "__VITE_ASSET__6a0daf8d__"